import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'flex',
      margin: [Spacings.s56, Spacings.s0],

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        flexDirection: 'column',
        margin: [Spacings.s56, 'auto'],
        width: 300,
      },
    },
    skeletonRoot: {
      extend: 'root',
      height: 500,
    },
    mainImage: {
      height: 450,
      '& > img': {
        display: 'block',
        width: '100%',
      },

      [mediaQuery(1023)]: {
        height: 300,
      },
    },
    arrow: {
      margin: [Spacings.s0, Spacings.s24],

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        margin: [Spacings.s24, Spacings.s0],
      },
    },
    arrowIcon: {
      fill: BackgroundColors.tint3,
      width: 45,
      height: '100%',
      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        transform: 'rotate(90deg)',
        margin: [Spacings.s0, 'auto'],
      },
    },
    carousel: {
      height: 'unset',

      [mediaQuery(1023)]: {
        height: 300,
      },
    },
  }),
  { name: 'brands-free-to-edit' },
);

export default useStyles;
